import {
  IMPORT_PROJECT,
  MODAL_NEW_GENERATE_PROJECT,
  MODAL_REPORT_PROJECT,
} from '@components/App/Modal/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export const useProjectActions = (workspaceId: ID, loading: boolean) => {
  const dispatch = useDispatch()

  const onCreate = () => {
    if (loading) {
      return
    }

    dispatch(DashboardActions.projects.create({ workspaceId }))
  }

  const teamId = workspaceId === PERSONAL_WORKSPACE_ID ? null : workspaceId

  const onImport = () => {
    dispatch(
      // @ts-expect-error
      openModal(IMPORT_PROJECT, {
        teamId,
        isLocked: true,
      })
    )
  }

  const onReport = () => {
    sendGtmEvent(GtmTriggerName.REPORT_TYPE_SELECTED)

    dispatch(
      // @ts-expect-error
      openModal(MODAL_REPORT_PROJECT, {
        teamId,
        isLocked: true,
      })
    )
  }

  const onGenerate = () => {
    sendGtmEvent(
      GtmTriggerName.AI_DASH_CLICK,
      'Click on AI Generate button in personal projects page'
    )

    // @ts-expect-error
    dispatch(openModal(MODAL_NEW_GENERATE_PROJECT, { teamId }))
  }

  return { onImport, onCreate, onGenerate, onReport }
}
